module.exports = __webpack_public_path__ + "img/284.a64d3810.svg";